<template>
  <v-form @submit.prevent="onSubmit" ref="form">
    <slot></slot>
  </v-form>
</template>
<script>
import get from 'lodash/get';
import set from 'lodash/set';

import Errors from './errors';

export default {
  props: {
    fields: { default: () => ({}), type: Object },
    method: { default: 'post' },
    action: { required: false },
    loading: { default: false, type: Boolean },
  },
  provide() {
    return {
      updateFieldValue: this.updateFieldValue,
      getFieldValue: this.getFieldValue,
      registerInput: this.registerInput,
      registerButton: this.registerButton,
    };
  },
  data() {
    return {
      currentFields: this.fields,
      formFields: {},
      inputs: {},
      button: null,
      errors: new Errors(),
    };
  },

  methods: {
    onSubmit() {
      if (this.action) {
        this.updateButtonLoadingState(true);
        this.$emit('update:loading', true);
        this.errors.clear();
        return this.$http[this.method](this.action, this.formFields)
          .then(data => {
            this.$refs.form.reset();
            this.$emit('submitted', data);
          })
          .catch(({ response }) => {
            const errors = get(response, 'data.errors');
            this.updateInputsErrors(errors);
            this.$emit('on-error', response);
            window.Notify.warning(
              get(response, 'data.message', get(response, 'message', 'Something went wrong')),
            );
          })
          .finally(() => {
            this.$emit('update:loading', false);
            this.updateButtonLoadingState(false);
            // clear the fields
          });
      }
    },
    updateInputsErrors(errors) {
      this.errors.set(errors);
      this.errors.keys().forEach(name => {
        this.updateInputErrors(name, this.errors.first(name));
      });
    },
    updateInputErrors(name, errors) {
      if (!this.inputs[name]) {
        return;
      }
      this.inputs[name].updateError(errors);
    },

    updateFieldValue(name, value) {
      this.formFields = set(this.formFields, name, value);
      this.errors.clear(name);
      this.updateInputErrors(name, null);
    },

    registerInput(input) {
      this.inputs[input.name] = input;
    },
    registerButton(button) {
      this.button = button;
    },
    updateButtonLoadingState(value) {
      if (!this.button) {
        return;
      }
      this.$set(this.button.$data, 'loading', value);
    },

    getFieldValue(name) {
      return get(this.currentFields, name, null);
    },
  },
};
</script>
